module.exports = __webpack_public_path__ + "assets/modeall.c510028b.svg";